(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-helium-cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bs-helium-cart-carousel')) {
    customElements.define('bs-helium-cart-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.scroller = this.querySelector('.scroll-area');
        this.previousButton = this.querySelector('.carousel--prev-button');
        this.nextButton = this.querySelector('.carousel--next-button');
        if (!this.scroller || !this.previousButton || !this.nextButton) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        const update = () => {
          const maximum = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
          this.previousButton.disabled = this.scroller.scrollLeft <= 2;
          this.nextButton.disabled = this.scroller.scrollLeft >= maximum - 2;
        };
        const move = (direction) => {
          const cards = this.scroller.querySelectorAll('.force-equal-height-wrapper');
          if (!cards.length) return;
          const step = cards.length > 1
            ? cards[1].offsetLeft - cards[0].offsetLeft
            : cards[0].offsetWidth;
          this.scroller.scrollBy({
            left: direction * step,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };
        this.previousButton.addEventListener('click', () => move(-1), { signal });
        this.nextButton.addEventListener('click', () => move(1), { signal });
        this.scroller.addEventListener('scroll', update, { passive: true, signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.scroller);
        const track = this.scroller.querySelector('product-list');
        if (track) this.resizeObserver.observe(track);
        update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bestsellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-bestsellers')) {
    customElements.define('home-bestsellers', class extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle) return;
        this.lifecycle = new AbortController();
        this.cache = new Map();
        this.requests = new WeakMap();
        this.pendingGrids = new WeakMap();
        const signal = this.lifecycle.signal;
        this.addEventListener('click', event => this.handleClick(event), { signal });
        this.addEventListener('shopify:block:select', event => {
          const button = Array.from(this.querySelectorAll('[data-occasion]')).find(item => item.dataset.occasion === event.detail.blockId);
          if (button) this.selectOccasion(button);
        }, { signal });
        this.rows = Array.from(this.querySelectorAll('[data-row]'));
        this.resizeObserver = new ResizeObserver(() => this.rows.forEach(row => this.updateArrows(row)));
        this.rows.forEach(row => {
          const viewport = row.querySelector('[data-viewport]');
          viewport.addEventListener('scroll', () => this.updateArrows(row), { signal, passive: true });
          viewport.addEventListener('focusout', () => queueMicrotask(() => this.applyPendingGrid(row)), { signal });
          this.resizeObserver.observe(viewport);
          this.loadRow(row);
        });
      }
      disconnectedCallback() {
        this.lifecycle?.abort();
        this.resizeObserver?.disconnect();
        this.lifecycle = null;
      }
      handleClick(event) {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-occasion')) this.selectOccasion(button);
        if (button.hasAttribute('data-step')) {
          const row = button.closest('[data-row]');
          const viewport = row.querySelector('[data-viewport]');
          const item = viewport.querySelector('.hb-product');
          const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(viewport.querySelector('.hb-grid')).gap || 0) : viewport.clientWidth;
          viewport.scrollBy({ left: Number(button.dataset.step) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
        if (button.hasAttribute('data-retry')) this.loadRow(button.closest('[data-row]'), true);
      }
      selectOccasion(button) {
        if (button.getAttribute('aria-pressed') === 'true') return;
        const row = this.querySelector('[data-row="products"]');
        if (!row) return;
        this.querySelectorAll('[data-occasion]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        row.dataset.url = button.dataset.url;
        row.dataset.label = button.textContent.trim();
        row.setAttribute('aria-labelledby', row.dataset.headingId + ' ' + button.id);
        const link = this.querySelector('[data-collection-link]');
        link.href = this.collectionUrl(button.dataset.url).href;
        link.querySelector('[data-collection-link-label]').textContent = button.dataset.linkLabel;
        const fallback = Array.from(this.querySelectorAll('[data-fallback]')).find(item => item.dataset.fallback === button.dataset.occasion);
        const viewport = row.querySelector('[data-viewport]');
        viewport.replaceChildren(...(fallback ? [fallback.content.cloneNode(true)] : []));
        viewport.scrollLeft = 0;
        row.querySelector('[data-status]').textContent = row.dataset.label + '. ' + this.dataset.loadingText;
        this.loadRow(row);
      }
      collectionUrl(path) {
        const url = new URL(path, location.origin);
        url.searchParams.set('sort_by', 'best-selling');
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        return url;
      }
      fetchProducts(path, retry) {
        const url = this.collectionUrl(path);
        url.searchParams.set('section_id', 'home-bestsellers-products');
        url.searchParams.set('filter.v.availability', '1');
        if (retry) this.cache.delete(url.href);
        if (!this.cache.has(url.href)) {
          const request = this.fetchPages(url);
          this.cache.set(url.href, request);
          request.catch(() => { if (this.cache.get(url.href) === request) this.cache.delete(url.href); });
        }
        return this.cache.get(url.href);
      }
      async fetchPages(url) {
        const pageUrl = new URL(url);
        const expectedHandle = decodeURIComponent(url.pathname.split('/').filter(Boolean).pop());
        const signal = this.lifecycle.signal;
        const result = document.createElement('div');
        result.className = 'hb-grid';
        result.setAttribute('role', 'list');
        let pageNumber = 1;
        while (result.children.length < 5) {
          const response = await fetch(pageUrl.href, { credentials: 'same-origin', signal });
          if (!response.ok) throw new Error('Section request failed');
          const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fragment = markup.querySelector('[data-bestseller-fragment]');
          if (!fragment || fragment.dataset.collection !== expectedHandle || fragment.dataset.sort !== 'best-selling') throw new Error('Invalid bestseller response');
          const grid = fragment.querySelector('.hb-grid');
          if (!grid || grid.querySelectorAll('.hb-product').length > 5) throw new Error('Invalid product row');
          Array.from(grid.querySelectorAll('.hb-product')).slice(0, 5 - result.children.length).forEach(card => result.append(card));
          const nextPage = Number(fragment.dataset.nextPage);
          if (!nextPage || result.children.length === 5) break;
          if (!Number.isInteger(nextPage) || nextPage <= pageNumber) throw new Error('Invalid collection pagination');
          pageNumber = nextPage;
          pageUrl.searchParams.set('page', String(pageNumber));
        }
        return result;
      }
      async loadRow(row, retry = false) {
        const requestId = Symbol();
        const lifecycle = this.lifecycle;
        const selectedUrl = row.dataset.url;
        this.requests.set(row, requestId);
        this.pendingGrids.delete(row);
        const viewport = row.querySelector('[data-viewport]');
        const status = row.querySelector('[data-status]');
        const hadProducts = Boolean(viewport.querySelector('.hb-product'));
        viewport.setAttribute('aria-busy', 'true');
        if (!hadProducts) {
          viewport.replaceChildren(this.querySelector('[data-loading-template]').content.cloneNode(true));
          status.textContent = this.dataset.loadingText;
        }
        this.updateArrows(row);
        try {
          const grid = await this.fetchProducts(selectedUrl, retry);
          if (!this.isConnected || this.lifecycle !== lifecycle || this.requests.get(row) !== requestId) return;
          this.pendingGrids.set(row, { grid, requestId, lifecycle, selectedUrl });
          this.applyPendingGrid(row);
        } catch (error) {
          if (!this.isConnected || this.lifecycle !== lifecycle || this.requests.get(row) !== requestId || error.name === 'AbortError') return;
          if (!hadProducts) {
            this.showMessage(viewport, this.dataset.errorText, true);
            status.textContent = this.dataset.errorText;
          } else {
            status.textContent = '';
          }
        } finally {
          if (this.isConnected && this.lifecycle === lifecycle && this.requests.get(row) === requestId) {
            viewport.setAttribute('aria-busy', 'false');
            this.updateArrows(row);
          }
        }
      }
      applyPendingGrid(row) {
        const pending = this.pendingGrids?.get(row);
        if (!pending) return;
        if (!this.isConnected || this.lifecycle !== pending.lifecycle || this.requests.get(row) !== pending.requestId || row.dataset.url !== pending.selectedUrl) {
          this.pendingGrids.delete(row);
          return;
        }
        const viewport = row.querySelector('[data-viewport]');
        if (viewport.contains(document.activeElement)) return;
        this.pendingGrids.delete(row);
        const count = pending.grid.querySelectorAll('.hb-product').length;
        if (count === 0) {
          this.showMessage(viewport, this.dataset.emptyText, false);
        } else {
          viewport.replaceChildren(pending.grid.cloneNode(true));
        }
        row.querySelector('[data-status]').textContent = this.dataset.loadedText.replace('{count}', count).replace('{occasion}', row.dataset.label || '');
        this.updateArrows(row);
      }
      showMessage(viewport, message, retry) {
        const box = document.createElement('div');
        box.className = 'hb-message';
        const text = document.createElement('p');
        text.textContent = message;
        box.append(text);
        if (retry) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hb-retry';
          button.setAttribute('data-retry', '');
          button.textContent = this.dataset.retryText;
          box.append(button);
        }
        viewport.replaceChildren(box);
      }
      updateArrows(row) {
        const viewport = row.querySelector('[data-viewport]');
        const arrows = row.querySelector('[data-arrows]');
        const maximum = viewport.scrollWidth - viewport.clientWidth;
        arrows.hidden = maximum < 2 || !viewport.querySelector('.hb-product');
        arrows.querySelector('[data-step="-1"]').disabled = viewport.scrollLeft <= 2;
        arrows.querySelector('[data-step="1"]').disabled = viewport.scrollLeft >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
